import {createAction, props} from '@ngrx/store';
import {ActivitiesLoaded} from '@automata/interfaces/activities-loaded';

export const LoadActivities = createAction('[Activities] Load Start');
export const LoadActivitiesComplete = createAction('[Activities] Load Complete', props<{response: ActivitiesLoaded}>());

export const ClearActivities = createAction('[Activities] Clear');
